const enhancedIncludes = (source, match) => {
  if (!Array.isArray(match))
    return !!~source.indexOf(match)
  for (let i = match.length - 1; i >= 0; i--)
    if (~source.indexOf(match[i]))
      return true
  return false
}

class Device {
  constructor () {
    this.agent = navigator.userAgent.toLowerCase(),
    this.detect = (match) => enhancedIncludes(this.agent, match)

    this.touchCapable = !!navigator.maxTouchPoints,
    this.pixelRatio = window.devicePixelRatio,
    this.system = {},
    this.system.retina = window.devicePixelRatio > 1,
    this.system.fullscreen = document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled,
    this.system.os = this.detect(['exokit']) && 'linux' == navigator.platform ? 'magicleap' : this.detect(['ipad', 'iphone', 'ios']) || this.detect('mac') && this.touchCapable && Math.max(screen.width, screen.height) < 1370 ? 'ios' : this.detect(['android', 'kindle']) ? 'android' : this.detect(['blackberry']) ? 'blackberry' : this.detect(['mac os']) ? 'mac' : this.detect(['windows', 'iemobile']) ? 'windows' : this.detect(['linux']) ? 'linux' : 'unknown',
    this.system.version = (() => {
      try {
        if ('ios' == this.system.os) {
          if (enhancedIncludes(this.agent, 'intel mac')) {
              let split = this.agent.split('version/')[1].split(' ')[0].split('.');
              return Number(split[0] + '.' + split[1])
          }
          let num = this.agent.split('os ')[1].split('_')
            , main = num[0]
            , sub = num[1].split(' ')[0];
          return Number(main + '.' + sub)
        }
        if ('android' == this.system.os) {
          let version = this.agent.split('android ')[1].split(';')[0];
          return version.length > 3 && (version = version.slice(0, -2)),
          '.' == version.charAt(version.length - 1) && (version = version.slice(0, -1)),
          Number(version)
        }
        if ('windows' == this.system.os)
          return enhancedIncludes(this.agent, 'rv:11') ? 11 : Number(this.agent.split('windows phone ')[1].split(';')[0])
      } catch (e) {}
      return -1
    })(),
    this.system.browser = 'ios' == this.system.os ? this.detect(['twitter', 'fbios']) ? 'social' : this.detect(['crios']) ? 'chrome' : this.detect(['safari']) ? 'safari' : 'unknown' : 'android' == this.system.os ? this.detect(['twitter', 'fb', 'facebook']) ? 'social' : this.detect(['chrome']) ? 'chrome' : this.detect(['firefox']) ? 'firefox' : 'browser' : this.detect(['msie']) || this.detect(['trident']) && this.detect(['rv:']) || this.detect(['windows']) && this.detect(['edge']) ? 'ie' : this.detect(['chrome']) ? 'chrome' : this.detect(['safari']) ? 'safari' : this.detect(['firefox']) ? 'firefox' : 'unknown',
    this.system.browserVersion = (() => {
      try {
        if ('chrome' == this.system.browser)
          return Number(this.agent.split('chrome/')[1].split('.')[0]);
        if ('firefox' == this.system.browser)
          return Number(this.agent.split('firefox/')[1].split('.')[0]);
        if ('safari' == this.system.browser)
          return Number(this.agent.split('version/')[1].split('.')[0].split('.')[0]);
        if ('ie' == this.system.browser)
          return this.detect(['msie']) ? Number(this.agent.split('msie ')[1].split('.')[0]) : this.detect(['rv:']) ? Number(this.agent.split('rv:')[1].split('.')[0]) : Number(this.agent.split('edge/')[1].split('.')[0])
      } catch (e) {
        return -1
      }
    })()
    ,
    this.mobile = !(window._NODE_ || !('ontouchstart'in window) && !('onpointerdown'in window) || !enhancedIncludes(this.system.os, ['ios', 'android', 'magicleap'])) && {},
    this.mobile && this.detect(['windows']) && !this.detect(['touch']) && (this.mobile = false),
    this.mobile && (this.mobile.tablet = Math.max(window.screen ? screen.width : window.innerWidth, window.screen ? screen.height : window.innerHeight) > 1e3,
    this.mobile.phone = !this.mobile.tablet,
    this.mobile.pwa = !(!window.matchMedia || !window.matchMedia('(display-mode: standalone)').matches) || !!navigator.standalone)
  }
}

export const {
  system,
  mobile,
  agent,
} = new Device()